import React, { ReactNode } from 'react';
import classNames from 'classnames';
import { Button } from 'ncoded-component-library';
import { useTranslation } from 'react-i18next';
import ArrowrightIcon from 'icons/Arrowright.icon';
import FloatingBanner from 'components/FloatingBanner';
import {
  FLOATING_BANBER_COLORS,
  FloatingBannerProps,
} from 'components/FloatingBanner/FloatingBanner.component';
import XIcon from 'icons/X.icon';

import './OnboardingPopup.styles.scss';

type OnboardingPopupProps = {
  className?: string;
  stepNumber?: number;
  totalSteps?: number;
  popupContent: ReactNode;
  gif?: string;
  onNext?: () => void;
} & FloatingBannerProps;

const OnboardingPopup: React.FC<OnboardingPopupProps> = (props) => {
  const {
    className,
    popupContent,
    totalSteps,
    gif,
    stepNumber = 1,
    onNext,
    onClose,
    ...rest
  } = props;

  const classes = classNames('onboarding-popup', className);

  const { t } = useTranslation();

  return (
    <FloatingBanner
      showOnPhablet
      hasOverlay
      className={classes}
      color={FLOATING_BANBER_COLORS.BLACK}
      onClose={onClose}
      {...rest}
    >
      <div className="onboarding-popup__content">
        <p>{popupContent}</p>

        {gif && <img src={gif} alt="Animated onboarding guide" />}

        {!!totalSteps && (
          <div>
            <p>
              {t('currentOfTotal', {
                current: stepNumber,
                total: totalSteps,
              })}
            </p>

            {stepNumber < totalSteps ? (
              <Button
                icon={ArrowrightIcon}
                variant="outline"
                iconPosition="right"
                onClick={onNext}
              >
                {t('next')}
              </Button>
            ) : (
              <Button
                icon={XIcon}
                variant="outline"
                iconPosition="right"
                onClick={onClose}
              >
                {t('close')}
              </Button>
            )}
          </div>
        )}
      </div>
    </FloatingBanner>
  );
};

export default OnboardingPopup;
